<template>
  <section class="mega-vertical-spacing">
    <div>
      <div class="md-vertical-spacing dashboard-job-module">
        <div v-for="job in eligibleJobs" :key="job.id">
          <div :class="jobCardClass">
            <SeekerJobCard v-once :job="job" :accountID="account.id" :accountType="accountType" />
            <div v-if="showShareJob" class="dashboard-job-module__divider"></div>
            <div v-if="showShareJob" class="dashboard-job-module__share-job-card">
              <div class="dashboard-job-module__row-item">
                <ProgressIcon class="dashboard-job-module__progress-icon min-w-16" color="#FF0064" :width="16" :height="16" />
                <div class="dashboard-job-module__col-item">
                  <h3 class="dashboard-job-module__content-slim xs-vertical-spacing-top body-1">
                    We're sharing your job with sitters
                  </h3>
                  <p class="text-small text-grey-clickable xs-vertical-spacing dashboard-job-module__content-slim">
                    {{ shareJobContent }}
                  </p>
                  <Button
                    v-if="accountType === 'basic'"
                    variant="primary"
                    href="/upgrade/pricing"
                    value="Upgrade now"
                    class="self-start mb-16"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Button v-if="jobs.length > 0" class="p-0" variant="text" href="/seeker/my-jobs/opened" value="All jobs" />
    </div>
  </section>
</template>

<script lang="ts">
import SeekerJobCard from './SeekerJobCard.vue';
import Button from '@/components/button/Button.vue';
import ProgressIcon from '@/graphics/icons/ProgressIcon.vue';
import { getSeasonalMessage } from './helpers/seasonalHelper';
import { Account } from '@/lib/public_api/Account';

export default {
  name: 'JobsModule',
  components: {
    SeekerJobCard,
    Button,
    ProgressIcon,
  },
  props: {
    jobs: {
      type: Array,
      required: true,
    },
    eligibleJobs: {
      type: Array,
      required: true,
    },
    account: {
      required: true,
      type: Account,
    },
  },
  computed: {
    showShareJob(): boolean {
      if (this.eligibleJobs.length !== 1) return false;

      const j = this.eligibleJobs[0] as any;
      if (['PENDING', 'JOB_STATUS_PENDING'].includes(j.status) || j.applications.totalCount > 0) return false;

      return true;
    },
    jobCardClass(): string {
      let cardClass = 'dashboard-job-module__card';
      if (this.oneJobAndNoApps) cardClass += ' dashboard-job-module__card--slim';
      return cardClass;
    },
    shareJobContent(): string {
      return this.premOrCorp ? 'You can also search for caregivers you like and reach out directly.' : getSeasonalMessage();
    },
    premOrCorp(): boolean {
      const accType = this.accountType;
      return accType === 'premium' || accType === 'corporate';
    },
    oneJobAndNoApps(): boolean {
      const oneJob = (this as any).eligibleJobs.length === 1;
      const noApps = (this.eligibleJobs[0] as any).applications.totalCount === 0;
      return oneJob && noApps;
    },
    accountType(): string | null {
      return this.account.accountType();
    },
  },
};
</script>
